import { staticPath } from "faqSrc/lib/$path";
import React, { BaseHTMLAttributes, FC, InputHTMLAttributes } from "react";
import styled from "styled-components";
import Image from "~/components/atoms/Image";
import { colorBlack } from "~/lib/constants";

interface Props {
  autocompleteInputProps?: any;
  iconSearchProps?: BaseHTMLAttributes<HTMLSpanElement>;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  isSmall?: boolean;
}

const InputSearch: FC<Props> = ({
  autocompleteInputProps,
  iconSearchProps,
  inputProps,
  isSmall = false,
}) => {
  return (
    <Container isSmall={isSmall}>
      <Input
        aria-label="検索"
        isSmall={isSmall}
        {...autocompleteInputProps}
        {...inputProps}
      />
      <ControlContainer>
        <SearchIconContainer isSmall={isSmall} {...iconSearchProps}>
          <Image
            src={staticPath.img.icon_search_svg}
            width={isSmall ? 24 : 28}
            height={isSmall ? 24 : 28}
            alt="search"
          />
        </SearchIconContainer>
      </ControlContainer>
    </Container>
  );
};

const Container = styled.div<{ isSmall: boolean }>`
  border-bottom: 1px solid ${colorBlack[500]};
  box-sizing: border-box;
  height: ${(props) => (props.isSmall ? "32px" : "44px")};
  line-height: ${(props) => (props.isSmall ? "32px" : "44px")};
  padding-left: 8px;
  position: relative;
  overflow: hidden;
`;

const Input = styled.input<{ isSmall: boolean }>`
  background-color: var(--body-bg-clr);
  border: none;
  box-sizing: border-box;
  color: var(--body-clr);
  font-weight: 700;
  font-size: ${(props) => (props.isSmall ? "16px" : "18px")};
  line-height: 30px;
  padding-right: 44px;
  width: 100%;

  ::-webkit-input-placeholder {
    /* Edge */
    color: ${colorBlack[200]};
    font-weight: normal;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${colorBlack[200]};
    font-weight: normal;
  }

  ::placeholder {
    color: ${colorBlack[200]};
    font-weight: normal;
  }

  ::-webkit-search-cancel-button {
    -webkit-appearance: none;
    cursor: pointer;
    font-size: 28px;
    background: url(${staticPath.img.icon_remove_svg}) center center no-repeat;
    background-size: 16px 16px;
    height: 24px;
    margin-right: 16px;
    width: 24px;
  }
`;

const ControlContainer = styled.div`
  position: absolute;
  right: 4px;
  top: 0;
`;

const SearchIconContainer = styled.span<{ isSmall: boolean }>`
  cursor: pointer;
  display: inline-block;
  padding: ${(props) => (props.isSmall ? "4px" : "8px")};
`;

export default InputSearch;
